import { Seo } from "../components/Seo";
import React, { useEffect, useState } from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";

export default function Policies() {
  const [data, setData] = useState({ intro: "", groups: [] });
  useEffect(() => { api.get("/policies").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="policies-page">
      <Seo title="Policies — Te Manawa Table Tennis Association" description="Te Manawa's policies for safe, inclusive and fair table tennis — conduct, safeguarding, health & safety, privacy and integrity, aligned with Table Tennis New Zealand." />
      <PageHero overline="Governance" title="Policies" subtitle="How we keep table tennis safe, fair and inclusive across the central North Island." />

      <section className="bg-cream py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          {data.intro && (
            <Reveal>
              <div className="flex items-start gap-4 bg-white border border-navy/10 p-6 md:p-8">
                <ShieldCheck size={28} weight="duotone" className="text-gold shrink-0 mt-1" />
                <p className="text-navy/75 leading-relaxed text-lg">{data.intro}</p>
              </div>
            </Reveal>
          )}

          {data.groups.map((group, gi) => (
            <Reveal key={group.category} delay={0.05 * gi} className="mt-12">
              <h2 className="font-heading text-3xl md:text-4xl text-navy font-medium tracking-tight mb-5 flex items-center gap-3">
                <span className="text-gold text-lg font-semibold">{String(gi + 1).padStart(2, "0")}</span>
                {group.category}
              </h2>
              <Accordion type="single" collapsible className="space-y-3">
                {group.policies.map((p) => (
                  <AccordionItem key={p.id} value={p.id} className="bg-white border border-navy/10 px-5" data-testid={`policy-${p.id}`}>
                    <AccordionTrigger className="font-heading text-lg text-navy hover:no-underline text-left">{p.title}</AccordionTrigger>
                    <AccordionContent className="pb-6">
                      <p className="text-navy/75 leading-relaxed whitespace-pre-line">{p.body}</p>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          ))}

          <Reveal className="mt-12">
            <div className="bg-navy-dark text-white/80 p-6 md:p-8 text-sm leading-relaxed">
              These summaries are provided for transparency. Full policy documents and the Table Tennis New Zealand Integrity Framework can be requested from the Te Manawa Board. To raise a concern or make a complaint, please use our <a href="/contact" className="text-gold hover:underline">Contact page</a>.
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
